<div class="panel-body ">
	<ng-container *ngFor="let pleading of civilCase.getPleadingList(); let pl = index">
		<div id="{{'civil-caseDetails-pleadings-' + pl}}" class="col-md-12 panel panel-default panel-margin-bottom panel-margin-top">
			<div class="panel-title">
				<span class="field-code ">V004a json='pleadings.clockDate''</span>
				<span id="{{'civil-caseDetails-pleadings-' + pl + '-clockDate'}}"> {{pleading.getClockDate() | date:'MM/dd/yyyy'}} </span>
				<span class="field-code ">V051a json='pleadings.pleadingType.description</span> 
				<span id="{{'civil-caseDetails-pleadings-' + pl + '-type'}}"> {{pleading.getType()}}</span>
			</div>
			<div class="panel-body" style="padding-left: 2em;">
				<ng-container *ngFor="let issue of civilCase.getIssueListByPleadingKey(pleading.getPleadingKey()); let is = index">
					<div class="col-md-12 panel panel-default panel-margin-bottom panel-margin-top">
						<div class="panel-title">
							<span id="{{'X005a-' + pl + '-' + is}}"> </span>
							<span class="field-code"> V005a json='issues.issueType.description'</span>
							<span id="{{'civil-caseDetails-pleadings-' + pl + '-issue-' + is + '-issueType'}}">{{issue.getTypeReplaceOther()}}</span>
							<span class="field-code ">V494 json='issues.status, issues.appealsRef#'</span>
							<span id="{{'civil-caseDetails-pleadings-' + pl + '-issue-' + is + '-issueStatus'}}">
							{{issue.getIssueStatus()}} {{issue.getIssueAppealed(civilCase)}}
							</span>
						</div>
						<div class="panel-body" >
							<div class="row" *ngIf="issue.getIssuePartyCodes().length === 0">
								<div class="col-md-12 panel panel-default ">
									<div class="panel-title ">
										<span class="field-code ">V057a json='issue.getIssuePartyCodes().length#','orders.orderResultCode.description' </span>
										<span id="{{'V057a-' + pl + '-' + is}}"> Result</span>
									</div>
									<div class="panel-body " id="{{'civil-caseDetails-pleadings-' + pl + '-issue-' + is + '-issueOrderResult'}}">
										{{pleading.getIssueOrderResult(issue.getIssueKey(), issue.getIssuePartyCodes(), civilCase.getOrderList())}} ({{pleading.getIssueOrderResultClockDate(issue.getIssueKey(),
										issue.getIssuePartyCodes(), civilCase.getOrderList()) | date:'MM/dd/yyyy'}})
									</div>
								</div>
							</div>
							<div class="row"  style="padding-left: 2em;">
								<ng-container *ngFor="let party of civilCase.getPartyListByIssueKey(issue.getIssueKey()); let pt = index">
									<div class="col-md-12 panel panel-default ">
										<div class="panel-title ">
											<span class="field-code">V050 V068d json='issues.issueOrderPartyRole.description'</span>
											<span id="{{'civil-caseDetails-pleadings-' + pl + '-issue-' + is + '-parties-' + pt + '-issueOrderpartyRole'}}">
												{{issue.getIssueOrderPartyRole(party)}}
											</span>
											<span id="{{'civil-caseDetails-pleadings-' + pl + '-issue-' + is + '-parties-' + pt + '-partyName'}}">
												{{party.getName()}}
											</span>
											<span class="field-code">V052c V053c json='parties.partyName', 'parties.partyNumber'</span>
											<span id="{{'civil-caseDetails-pleadings-' + pl + '-issue-' + is + '-parties-' + pt + '-partyRolePartyNumber'}}">											
											 ({{party.getPartyRole()}} {{party.getPartyNumber()}})
											</span>

										</div>

										<!-- Don't show this panel row if there's no data in the columns based on the orderRef -->
										<div class="panel-body" *ngIf="issue.getIssueOrderPartyOrderRef(party) !== ''" style="padding-left: 2em;">
											<div class="row row-eq-height">
												<div class="col-md-4 panel panel-default ">
													<div class="panel-title ">
														<span class="field-code ">V495 (V057) json='orders.orderResultCode.description','orders.clockDate' </span>
														<span id="{{'V495-' + pl + '-' + is + '-' + pt}}"> Result</span>
													</div>
													<div class="panel-body " id="{{'civil-caseDetails-pleadings-' + pl + '-issue-' + is + '-parties-' + pt + '-partyOrderResult'}}">														
														<div *ngIf="pleading.getPartyOrderResultClockDate(issue.getIssueOrderPartyOrderRef(party), civilCase.getOrderList()) !== ''" 
															id="{{'civil-caseDetails-pleadings-' + pl + '-issue-' + is + '-parties-' + pt + '-partyOrderResultWithClockDate'}}">
															{{pleading.getPartyOrderResult(issue.getIssueOrderPartyOrderRef(party), civilCase.getOrderList())}}
															({{pleading.getPartyOrderResultClockDate(issue.getIssueOrderPartyOrderRef(party), civilCase.getOrderList()) | date:'MM/dd/yyyy'}})
														</div>	
														<div *ngIf="pleading.getPartyOrderResultClockDate(issue.getIssueOrderPartyOrderRef(party), civilCase.getOrderList()) === ''" 
															id="{{'civil-caseDetails-pleadings-' + pl + '-issue-' + is + '-parties-' + pt + '-partyOrderResultWithoutClockDate'}}">
														{{pleading.getPartyOrderResult(issue.getIssueOrderPartyOrderRef(party), civilCase.getOrderList())}}
													</div>												
													</div>
												</div>

												<div class="col-md-4 panel panel-default " 
													*ngIf="pleading.getPartyAbstractRecordedIn(civilCase, issue.getIssueOrderPartyAbstractRef(party), issue.getIssueOrderPartyOrderRef(party), civilCase.getOrderList()) !== ''
													    || pleading.getPartyPreJAAbstractInfo(issue.getIssueOrderPartyAbstractRef(party), civilCase, issue.getIssueOrderPartyOrderRef(party), civilCase.getOrderList()) !== ''">
													<div class="panel-title ">
														<span class="field-code ">V058a json='orders.docketBookNum','orders.docketPageNum' </span> 														
														<span id="{{'V058a-' + pl + '-' + is + '-' + pt}}">Abstract Is Recorded in</span>
													</div>
													<div class="panel-body " id="{{'civil-caseDetails-pleadings-' + pl + '-issue-' + is + '-parties-' + pt + '-partyAbstractRecordedIn'}}">
														{{pleading.getPartyAbstractRecordedIn(civilCase, issue.getIssueOrderPartyAbstractRef(party), issue.getIssueOrderPartyOrderRef(party), civilCase.getOrderList())}} 
														{{pleading.getPartyPreJAAbstractInfo(issue.getIssueOrderPartyAbstractRef(party), civilCase, issue.getIssueOrderPartyOrderRef(party), civilCase.getOrderList())}}														
													</div>
												</div>

												<div class="col-md-4 panel panel-default " 
												    *ngIf="pleading.getPartyAbstractRecordedIn(civilCase, issue.getIssueOrderPartyAbstractRef(party), issue.getIssueOrderPartyOrderRef(party), civilCase.getOrderList()) === '' 
												       && pleading.getPartyAbstractInfo(issue.getIssueOrderPartyAbstractRef(party), civilCase) !== '-'">
													<div class="panel-title">
														<span class="field-code ">V189e/V230e  json='orders.abstractRef#', 'abstract.abstractNumber' </span>
														<span id="{{'V189e/V230e -' + pl + '-' + is + '-' + pt}}"> 
															Judgment Number
														</span>
													</div>
													<div class="panel-body" id="{{'civil-caseDetails-pleadings-' + pl + '-issue-' + is + '-parties-' + pt + '-partyAbstractInfo'}}">
														{{pleading.getPartyAbstractInfo(issue.getIssueOrderPartyAbstractRef(party), civilCase)}}
													</div>
												</div>
													<div class="col-md-4 panel panel-default " *ngIf="issue.getIssueIndexedOnDate(party) !== ''">
														<div class="panel-title ">
															<span class="field-code ">V030 json='issueOrderPartyRef.casePartyRef#','indexedOn' </span>
															<span id="{{'V030-' + pl + '-' + is + '-' + pt}}"> 
																Judgment Indexed On
															</span>
														</div>
														<div class="panel-body ">
															<div *ngIf="issue.getIssueIndexedOnDate(party) !== ''" id="{{'civil-caseDetails-pleadings-' + pl + '-issue-' + is + '-parties-' + pt + '-issueIndexedOn'}}">
																{{issue.getIssueIndexedOnDate(party) | date:'MM/dd/yyyy'}} {{issue.getIssueIndexedOnDate(party) | date:'hh:mm a'}}
															</div>
															<div *ngIf="issue.getIssueIndexedOnDate(party) === ''" id="{{'civil-caseDetails-pleadings-' + pl + '-issue-' + is + '-parties-' + pt + '-issueIndexedOn'}}">
																-
															</div>
														</div>
													</div>												
											</div>
										</div>
									</div>
								</ng-container>
							</div>
						</div>
					</div>
				</ng-container>
				<div class="row">
					<div class="col-md-12 panel panel-default " *ngIf="pleading.getResponseList(pleading).length !== 0">
						<div class="panel-title ">
							<span id="{{'X068f-' + pl}}">Responses</span>
						</div>
						<div class="panel-body table-responsive">
							<table id="pleadings-responses" class="table table-condensed table-striped ">
								<thead>
									<tr>
										<th>
											<span class="field-code ">V068f V052e V053e json='parties.partyNumber, partyList.partyRole.description','partyList.partyNumber'</span>
											<span id="V068f">Responding Party</span>
										</th>
										<th>
											<span class="field-code ">V130 json='responseType.description#'</span>
											<span id="V130">Response Status</span>
										</th>
										<th>
											<span class="field-code ">V129 json='pleading.clockDate'</span>
											<span id="V129">Response Date</span>
										</th>
									</tr>
								</thead>
								<tbody>
									<tr *ngFor="let response of pleading.getResponseList(pleading); let rs = index;">
										<td>
											<div *ngIf="pleading.getRespondingPartyList(response).length !== 0">
												<tr id="{{'civil-caseDetails-pleadings-' + pl + '-responses-' + rs + '-partyName-' + rp}}" 
												    *ngFor="let party of pleading.getRespondingPartyList(response); let rp = index;">
													{{civilCase.getPartyNameByPartyNumber(party.partyNumber)}} 
													({{pleading.getRespondingPartyDescription(party)}} {{party.partyNumber}})
												</tr>
											</div>
											<div id="{{'civil-caseDetails-pleadings-' + pl + '-responses-' + rs + '-partyName-0'}}"
											    *ngIf="pleading.getRespondingPartyList(response).length === 0">
												-
											</div>
										</td>																			
										<td id="{{'civil-caseDetails-pleadings-' + pl + '-responses-' + rs + '-responseStatus'}}">
											{{pleading.getResponseStatus(response)}}
										</td>
										<td *ngIf="pleading.getResponseClockDate(response) !== ''" id="{{'civil-caseDetails-pleadings-' + pl + '-responses-' + rs + '-responseClockDate'}}">
											{{pleading.getResponseClockDate(response) | date:'MM/dd/yyyy'}}
										</td>
										<td *ngIf="pleading.getResponseClockDate(response) === ''" id="{{'civil-caseDetails-pleadings-' + pl + '-responses-' + rs + '-responseClockDate'}}">
											-
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>
		</div>
	</ng-container>
</div>


// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/case-view/civil/pleadings/pleadings.component.html